var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrincipalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247.855,
    height: 63.453,
    viewBox: "0 0 247.855 63.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(-52 -54.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(52 101.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M274.683,1461.57v3.131h-6.571v6.026H264.6v-15.753h11.791v3.131h-8.28v3.464Z",
    transform: "translate(-264.6 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M329.481,1454.975h3.511v15.753h-3.511Z",
    transform: "translate(-315.298 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M364.384,1459.031h-.047v11.7h-3.393v-15.753h4.816l5.955,10.581h.047v-10.581h3.393v15.753h-4.223Z",
    transform: "translate(-339.884 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M447.134,1468.071H439.9l-1.068,2.657h-3.677l6.714-15.753h3.393l6.714,15.753H448.2Zm-3.653-9.063-2.4,6.05h4.863l-2.42-6.05Z",
    transform: "translate(-397.871 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M524.739,1459.031h-.047v11.7H521.3v-15.753h4.817l5.955,10.581h.047v-10.581h3.393v15.753h-4.223Z",
    transform: "translate(-465.186 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M610.615,1455.123v3.843h-.166a5.553,5.553,0,0,0-4.508-1.946,4.983,4.983,0,1,0,0,9.965,5.516,5.516,0,0,0,4.508-1.945h.166v3.843a8.206,8.206,0,0,1-4.84,1.234c-5.03,0-8.422-3.369-8.422-8.114s3.393-8.114,8.422-8.114A7.988,7.988,0,0,1,610.615,1455.123Z",
    transform: "translate(-524.615 -1453.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M670.806,1454.975h3.511v15.753h-3.511Z",
    transform: "translate(-582.012 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M708.063,1468.071h-7.236l-1.068,2.657h-3.677l6.714-15.753h3.393l6.714,15.753h-3.772Zm-3.653-9.063-2.4,6.05h4.863l-2.42-6.05Z",
    transform: "translate(-601.762 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M782.231,1470.728v-15.753h3.511V1467.6h7.948v3.131Z",
    transform: "translate(-669.08 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M877.171,1455.052v3.63H877a6.775,6.775,0,0,0-4.816-1.685c-1.732,0-2.823.664-2.823,1.732,0,.9.688,1.305,3.037,1.566,4.152.45,5.718,1.874,5.718,4.887,0,3.155-2.278,4.935-6.311,4.935a10.268,10.268,0,0,1-5.859-1.376v-3.63h.166a8.617,8.617,0,0,0,5.575,1.9c1.922,0,2.942-.593,2.942-1.732,0-.949-.735-1.376-3.131-1.637-4.057-.451-5.623-1.8-5.623-4.7,0-3.155,2.372-5.053,6.358-5.053A9.577,9.577,0,0,1,877.171,1455.052Z",
    transform: "translate(-734.442 -1453.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M943.12,1464.3h-6.572v3.3h8.28v3.131H933.037v-15.753h11.791v3.131h-8.28v3.25h6.572Z",
    transform: "translate(-786.92 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1003.381,1470.728H999.87v-15.753h7.07c3.939,0,5.955,1.756,5.955,5.148,0,2.515-1.115,4.128-3.3,4.768l3.772,5.836h-4.128l-3.2-5.48h-2.657Zm3.416-8.612c1.732,0,2.538-.641,2.538-1.992,0-1.376-.807-2.017-2.538-2.017h-3.416v4.009Z",
    transform: "translate(-839.144 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1070.638,1470.728l-6.216-15.753h3.772l4.2,11.222h.047l4.176-11.222h3.677l-6.216,15.753Z",
    transform: "translate(-889.585 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1146.229,1454.975h3.511v15.753h-3.511Z",
    transform: "translate(-953.51 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1186.612,1455.123v3.843h-.166a5.553,5.553,0,0,0-4.508-1.946,4.983,4.983,0,1,0,0,9.965,5.516,5.516,0,0,0,4.508-1.945h.166v3.843a8.206,8.206,0,0,1-4.84,1.234c-5.03,0-8.422-3.369-8.422-8.114s3.393-8.114,8.422-8.114A7.988,7.988,0,0,1,1186.612,1455.123Z",
    transform: "translate(-974.702 -1453.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1256.886,1464.3h-6.572v3.3h8.28v3.131H1246.8v-15.753h11.791v3.131h-8.28v3.25h6.572Z",
    transform: "translate(-1032.099 -1454.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1321.781,1455.052v3.63h-.167A6.775,6.775,0,0,0,1316.8,1457c-1.732,0-2.823.664-2.823,1.732,0,.9.688,1.305,3.037,1.566,4.152.45,5.718,1.874,5.718,4.887,0,3.155-2.278,4.935-6.311,4.935a10.269,10.269,0,0,1-5.86-1.376v-3.63h.166a8.617,8.617,0,0,0,5.575,1.9c1.922,0,2.942-.593,2.942-1.732,0-.949-.735-1.376-3.131-1.637-4.057-.451-5.623-1.8-5.623-4.7,0-3.155,2.372-5.053,6.358-5.053A9.576,9.576,0,0,1,1321.781,1455.052Z",
    transform: "translate(-1081.863 -1453.889)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(52.33 54.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M272.22,1248.638h-6.109v32.508h6.04v-21.422l8.4,14.62H285.1l8.394-14.62v21.422h6.044v-32.508h-6.1l-10.61,18.93Z",
    transform: "translate(-266.111 -1246.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M940.126,1248.638H933.9v32.508h21.413V1275.5H940.126Z",
    transform: "translate(-787.926 -1246.279)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 6.224,
    height: 32.508,
    transform: "translate(127.336 2.359)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 6.224,
    height: 32.508,
    transform: "translate(175.329 2.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1307.945,1275.5v-8.287h13.3v-5.524h-13.3v-7.342h14.922v-5.707H1301.72v32.508h21.146V1275.5Z",
    transform: "translate(-1075.342 -1246.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1168.671,1254.347v-5.709h-23.406v5.707h16.016l-16.851,21.153v5.647h24.277V1275.5h-16.572Z",
    transform: "translate(-952.434 -1246.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M470.043,1255.693a11.505,11.505,0,0,1,17.46-9.842v-6.983a17.846,17.846,0,0,0-23.115,21.731h6.754A11.454,11.454,0,0,1,470.043,1255.693Z",
    transform: "translate(-420.507 -1237.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M541.994,1308.96a11.505,11.505,0,0,1-17.46,9.842v6.983a17.846,17.846,0,0,0,23.115-21.731H540.9A11.454,11.454,0,0,1,541.994,1308.96Z",
    transform: "translate(-468.044 -1289.581)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 6.707,
    height: 40.929,
    transform: "matrix(0.669, 0.743, -0.743, 0.669, 74.708, 2.428)",
    fill: "#f84300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M700.83,1264.056c3.019-.929,4.386-3.576,4.386-6.548,0-5.294-3.55-8.87-11.352-8.87H680.342v32.508h14.265c8.777,0,12.234-3.9,12.234-9.567A7.247,7.247,0,0,0,700.83,1264.056Zm-14.372-9.711h7.371c3.44,0,5.229,1.035,5.229,3.8,0,2.666-1.789,3.925-5.229,3.925h-7.371Zm8,21.153h-8v-8.644h8c3.973,0,5.863,1.449,5.863,4.384C700.321,1274.223,698.432,1275.5,694.459,1275.5Z",
    transform: "translate(-589.793 -1246.279)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincipalLogo);
export default __webpack_public_path__ + "static/media/principal-logo.129689a921d4198b6f1d831cfe01ffc2.svg";
export { ForwardRef as ReactComponent };